import React from "react";
import { IMovimento, Processo } from "@/modelo";
import { DadosProcessoDto } from "@/modelo/dto/DadosProcessoDto";
import { UtilData } from "@/misc/UtilData";
import { Chip } from "@mui/material";

interface IViewMovimentoProcessoProps {
    movimentos?: IMovimento[];
    dadosProcesso?: DadosProcessoDto;
}

const ViewMovimentoProcesso: React.FC<IViewMovimentoProcessoProps> = ({
    movimentos = [],
    dadosProcesso,
}) => {
    const numberToReal = (num?: number) => {
        return num
            ? num.toLocaleString("pt-br", { style: "currency", currency: "BRL" })
            : "R$ 0,00";
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                marginRight: "10px",
                marginTop: "15px"
            }}
        >
            {movimentos.length > 0 && (
                <span
                    className="titulo"
                    style={{ fontWeight: "bold", marginLeft: "15px", marginBottom: "-15px" }}
                >
                    Movimentos:
                </span>
            )}

            <ul>
                {movimentos.map((movimento, i) => (
                    <li key={i}>
                        {UtilData.dataSemHora(movimento.atualizadoEm)} -{" "}
                        {movimento.textoFinalInterno}
                    </li>
                ))}
            </ul>

            {dadosProcesso && dadosProcesso?.origem !== 'L' &&
                <span style={{ marginTop: "15px" }}>
                    <span className="titulo" style={{ fontWeight: "bold", marginLeft: "15px" }}>
                        Valor da Causa:
                    </span>
                    <span>
                        &nbsp;{dadosProcesso && numberToReal(dadosProcesso.valorDaCausa)}
                    </span>
                </span>
            }

            {dadosProcesso?.assuntoList?.length > 0 && (
                <div
                    style={{ marginLeft: "15px", marginTop: "15px" }}
                    className="titulo"
                >
                    <b>Assuntos:</b>
                </div>
            )}

            <span style={{ display: "flex", flexWrap: "wrap" }}>
                {dadosProcesso?.assuntoList?.map((assunto, i) => {
                    let label = assunto.descricao;
                    if (assunto.assunto?.codigo) {
                        label = `${assunto.assunto.codigo} - ${assunto.assunto.descricao}`;
                    } else if (assunto.descricaoCompleta) {
                        label = `${assunto.codigoAssunto} - ${assunto.descricaoCompleta}`;
                    }
                    return (
                        <Chip
                            key={i}
                            style={{ marginBottom: "5px", marginLeft: "15px" }}
                            label={label}
                        />
                    );
                })}
            </span>
        </div>
    );
};

export default ViewMovimentoProcesso;
